class UserInfoStore {
    static getInfo() {
        return JSON.parse(localStorage.getItem(`operators_info`));
    }

    static setInfo(value) {
        return localStorage.setItem(`operators_info`, JSON.stringify(value));
    }

    static removeInfo() {
        return localStorage.removeItem(`operators_info`)
    }
}

export default UserInfoStore;